import React, { useEffect, useState } from 'react'
import Bredcrum from '../../common/Bredcrum'
import InstructorList from './InstructorList'
// import team1 from "../../../assets/images/team/team-1.jpg"
// import team2 from "../../../assets/images/team/team-2.jpg"
// import team3 from "../../../assets/images/team/team-3.jpg"
import { axiosInstance } from '../config'
import Loader from '../../common/Loader'

const InstructorIndex = () => {

    const [loading,setLoading] = useState(false);
    const [Instructors , setInstructors] = useState([]);

    useEffect(() => {
        getInstructors();
    },[])

    function getInstructors() {
        setLoading(true)
        axiosInstance.get(`getinstructors`)
        .then(res => {
            // Reverse the newData array
            const reversedData = res.data.instructors.filter(item => Number(item?.status) === 0).reverse(); // Make sure not to mutate the original array
            
            // Set reversed data to both states
            setInstructors(reversedData);            
        })
        .catch((err) => console.log(err))
        .finally(() => {
            setLoading(false)
        })
    }

    return (
        <>
        {loading && <Loader />}
            <Bredcrum
                heading={'Instructors'}
                path={[
                    { name: 'Instructors', path: 'instructors' },
                ]}
            />
            <InstructorList instructors={Instructors} />
        </>
    )
}

export default InstructorIndex